<template>
<Form class="form-default form-flex clearfix mb-10" :inline="true">
  <div class="flex-col"
    v-for="(item, ind) in customFieldsArray" v-bind:key="ind">
    <FormInput
    :field="item"
    :fieldValue="customFieldValues[item.name]"
    :orderNumber="orderNumber"
    :isTransporter="isTransporter"
    :orderStatus="currentIndent.status"
    :isSourceUser="isSourceUser"
    :isDestinationUser="isDestinationUser"
    @updateFieldValue="updateFieldValue(item, $event)" />
  </div>
</Form>
</template>
<script>
import FormInput from './FormInput';
export default {
  props:{
    currentIndent: {
      type: Object,
      default: () =>({}),
    },
    indentCustomFields:{
      type: Array,
      default: () =>([]),
    },
    indentSourceCustomFields:{
      type: Array,
      default: () =>([]),
    },
    indentDestinationCustomFields:{
      type: Array,
      default: () =>([]),
    },
    isTransporter: {
      type: Boolean,
      default: false,
    },
    customFields:{
      type: Object,
      default: () =>({}),
    }
  },
  components:{
    FormInput,
  },
  data() {
    return {
      customFieldValues: {},
      currentSelected: null,
      tempValue: null,
    };
  },
  created() {
    this.customFieldValues = Object.assign({}, this.customFields);
  },
  computed: {
    orderNumber() {
      if (this.isTransporter) {
        return this.currentIndent.order_no;
      }
      return this.currentIndent.order_number;
    },
    isSourceUser() {
      if (!this.isTransporter) {
        const sourceLocationIds = this.currentIndent.sources.map(source => source.location_id.toString());
        let flag = false;
        sourceLocationIds.map(location => {
          const depot = this.$depot.depot(location);
          const vendor = this.$depot.vendor(location);
          if ((depot && depot.id == location) || (vendor && vendor.id == location)) {
            flag = true;
          }
        });
        return flag;
      } else {
        return true;
      }
    },
    isDestinationUser() {
      if (!this.isTransporter) {
        const destinationLocationIds = this.currentIndent.destinations.map(destination => destination.location_id.toString());
        let flag = false;
        destinationLocationIds.forEach(location => {
          const depot = this.$depot.depot(location);
          const vendor = this.$depot.vendor(location);
          if ((depot && depot.id === location) || (vendor && vendor.id === location)) {
            flag = true;
          }
        });
        return flag;
      } else {
        return true;
      }
    },
    customFieldsArray() {
      this.indentCustomFields.forEach((field) => {
        field.custom_field_type = 'indent';
      });
      this.indentDestinationCustomFields.forEach((field) => {
        field.custom_field_type = 'indent_destination';
      });
      this.indentSourceCustomFields.forEach((field) => {
          field.custom_field_type = 'indent_source';
      });
      return [...this.indentCustomFields,
        ...this.indentDestinationCustomFields,
        ...this.indentSourceCustomFields ];
    },
  },
  methods: {
    updateFieldValue(item, value){
      this.customFieldValues[item.name] = value;
      this.customFieldValues = Object.assign({}, this.customFieldValues);
    }
  },
};
</script>
